module.exports = __webpack_public_path__ + "img/download.9a5d0726.png";